import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/hooks/useDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import TaxRevenueTypesContent from './TaxRevenueTypesContent';

const form = {
  q: '',
};

function TaxRevenueTypesContainer({
  match,
  history,
  getTaxRevenueTypesList,
  taxRevenueTypesList,
  isLoading,
  taxRevenueTypesListPager,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CreateModal
          latestYear={_.get(taxRevenueTypesList, '0.attributes.year_from')}
        />
      ),
      title: 'Add Tax Revenue Types',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Tax Revenue Types',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getTaxRevenueTypesList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.q,
    sort_by: 'asc',
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getTaxRevenueTypesList({ q: formData.q, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <Route
      path={`${match.path}/:taxRevenueTypeId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Tax Revenue Types"
          getData={getTaxRevenueTypesList}
          setParams={param}
          setKeyword={handleOnChange}
          keyword={_.get(formData, 'q') || ''}
          keywordPlaceholder="Search..."
          pathName={`${match.path}/:taxRevenueTypeId?`}
          listName="taxRevenueTypes"
          label="Tax Revenue Types"
          renderItem={(item) => (
            <div className="p-3">{_.get(item, 'attributes.name')}</div>
          )}
          isLoading={isLoading}
          selected={params.taxRevenueTypeId}
          data={taxRevenueTypesList}
          dataPager={taxRevenueTypesListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:taxRevenueTypeId?`}
                  render={() => (
                    <TaxRevenueTypesContent
                      handleAddModal={handleAddModal}
                      handleEdit={handleEdit}
                      // handleRemove={handleRemove}
                    />
                  )}
                />
              </Switch>
              <Route
                path={`${match.path}/:taxRevenueTypeId?`}
                render={() =>
                  !params.taxRevenueTypeId &&
                  taxRevenueTypesList.length > 0 ? (
                    <Redirect
                      to={`${match.url}/${_.get(
                        taxRevenueTypesList,
                        '0.id'
                      )}`}
                    />
                  ) : null
                }
              />
            </React.Fragment>
          )}
        />
      )}
    />
  );
}

TaxRevenueTypesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getTaxRevenueTypesList: PropTypes.instanceOf(Function).isRequired,
  taxRevenueTypesList: PropTypes.instanceOf(Array).isRequired,
  taxRevenueTypesListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  taxRevenueTypesList: _.get(api, `${c.GET_TAX_REVENUE_TYPES}.list`) || [],
  taxRevenueTypesListPager:
    _.get(api, `${c.GET_TAX_REVENUE_TYPES}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_TAX_REVENUE_TYPES) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxRevenueTypesContainer);
